import type { ReactNode } from "react";
import { cx } from "@/utils/cx";

const PANEL_BACKGROUND = {
  background:
    "linear-gradient(158deg, var(--color-unbox-dark-brand-end) 0%, var(--color-unbox-dark-brand-start) 52%, var(--color-unbox-dark-brand-mid) 100%)",
};

export const AuthSplitLayout = ({ banner, children }: { banner?: ReactNode; children: ReactNode }) => (
  <div className="fixed inset-0 z-50 flex flex-col overflow-y-auto bg-unbox-cream-25">
    {banner}
    <div className="flex flex-1 p-5">
      <div className="relative hidden w-[46%] shrink-0 overflow-hidden rounded-2xl md:block" style={PANEL_BACKGROUND}>
        <img
          src="/auth-portrait.webp"
          alt=""
          aria-hidden
          className="absolute inset-0 size-full object-cover object-[40%_10%] opacity-70"
        />
        <img src="/unbox-logo-gradient.svg" alt="Unbox" width={228} className="absolute top-12 left-12" />
      </div>
      <div className="flex flex-1 items-center justify-center px-6 py-16">{children}</div>
    </div>
  </div>
);

export const AuthTitle = ({ children }: { children: ReactNode }) => (
  <h1 className="text-[32px] leading-10 font-semibold text-gray-900">{children}</h1>
);

export const AuthDescription = ({ children }: { children: ReactNode }) => (
  <p className="mt-3 text-sm leading-5 text-gray-600">{children}</p>
);

export const AuthLinkButton = ({
  onClick,
  isDisabled,
  className,
  children,
}: {
  onClick: () => void;
  isDisabled?: boolean;
  className?: string;
  children: ReactNode;
}) => (
  <button
    type="button"
    onClick={onClick}
    disabled={isDisabled}
    className={cx(
      "cursor-pointer self-center text-[13px] font-medium text-brand-700 underline underline-offset-2 hover:text-brand-900",
      className,
    )}
  >
    {children}
  </button>
);
